<template>
  <el-dialog
    title="Chuyển lớp học sinh"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    custom-class="sk-dialog"
  >
    <div class="sk-dialog-content">
      <div class="sk-panel">
        <div class="sk-panel-head">
          <div class="sk-panel-icon" style="background: linear-gradient(135deg, #34d399, #059669)">
            <i class="el-icon-s-operation"></i>
          </div>
          <div>
            <p class="sk-panel-title">Chuyển lớp học sinh</p>
            <p class="sk-panel-subtitle">Chọn lớp muốn chuyển tới cho các học sinh đã chọn.</p>
          </div>
        </div>
        <el-form
          label-width="160px"
          :model="dataImput"
          label-position="left"
          :rules="rules"
          ref="dataImput"
        >
          <el-form-item label="Chọn lớp chuyển tới" prop="idClass">
            <el-select
              v-model="dataImput.idClass"
              filterable
              clearable
              placeholder="Chọn lớp học"
              style="width: 100%"
            >
              <el-option
                v-for="item in classList"
                :key="item.id"
                :value="item.id"
                :label="item.className"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <span slot="footer" class="dialog-footer sk-dialog-footer">
      <el-button class="btn-cancel" type="danger" size="medium" @click="closeDialogByButton('dataImput')">
        <i class="el-icon-circle-close" />
        <span>Đóng</span>
      </el-button>
      <el-button
        class="btn-save"
        type="success"
        size="medium"
        :loading="loadingButton"
        mini
        @click="submitForm('dataImput')"
      >
        <i class="el-icon-circle-check" />
        <span>Lưu</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import StudentService from "@/services/StudentService";
import {mapGetters} from "vuex";
export default {
  props: {
    dialogVisible: null,
  },
  data() {
    return {
      dataSuccess: null,
      loadingButton: false,
      classList: [],
      dataImput: {
        idClass: "",
        kidList: [],
      },
      rules: {
        idClass: [
          {
            required: true,
            message: "Lớp không được để trống",
            trigger: "blur",
          },
          {
            required: true,
            message: "Lớp không được để trống",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed:{
    ...mapGetters('classStore',['classListCommon'])
  },
  created() {
    this.$store.dispatch('classStore/fetchDataClassListCommon')
  },
  methods: {
    //reset when click x
    closeDialog() {
      this.$refs["dataImput"].resetFields();
      this.$emit("dialog-close");
    },
    //click when click button
    closeDialogByButton(fromData) {
      this.$refs[fromData].resetFields();
      this.$emit("dialog-close");
    },

    submitForm(fromData) {
      this.$refs[fromData].validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          StudentService.changeClass(this.dataImput)
            .then((response) => {
              this.dataSuccess = response.data.data;
              this.$message({
                message: "Chuyển đổi lớp thành công",
                type: "success",
              });
              setTimeout(() => {
                this.closeDialogByButton(fromData);
              }, 500);
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.loadingButton = false;
              }, 500);
            });
        } else {
          console.log("error validate data!");
          return false;
        }
      });
    },
    getClassDataInitial(data) {
      this.dataImput.kidList = data;
      this.classList = this.classListCommon;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";
</style>
